import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import {
    Badge,
    TextField,
    Typography,
    Popover,
    Tooltip,
    InputAdornment,
    IconButton,
    Modal
} from '@material-ui/core';

import { Visibility, VisibilityOff } from "@material-ui/icons";

import Swal from 'sweetalert2';

import '../../styles/style.scss';
import '../../styles/loginScreenStyle.scss';

import { Link } from 'react-router-dom';
import { Footer } from '../shared/Footer';

import { login } from "../../actions/auth";

 import TokenService from "../../services/auth/generateToken.service";

import PDFTyP from "../../assets/documents/Escaneado5ago202111.34 a.m.pdf";
import PDFCom from "../../assets/documents/Comunicado.pdf";

import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import authService from "../../services/auth/auth.service";
import termsAndConditionsService from "../../services/termsAndConditions.service";

export const LoginScreen = (props) => {

    const divRev = useRef();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

      
    const [isDisabled, setDisabled] = useState(false);

    const [values, setValues] = useState({
        showPassword: false,
    });

    const validationSchema = Yup.object().shape({
    an8: Yup.string().required('AN8 es requerido'),
    password: Yup.string().required('Contraseña es requerida')
    },[]);

    const {
    register,
    handleSubmit,
    formState: { errors }
    } = useForm({
    resolver: yupResolver(validationSchema)
    });

    const dispatch = useDispatch();
    useEffect(() => {
        const alreadySeen = localStorage.getItem("modal_invitation")
        if (alreadySeen === "seen") localStorage.setItem("modal_invitation", "")
        termsAndConditionsService.getPrivacyAdvertice().then((response)=>{
            localStorage.setItem("pdfName", response.name);
                }).catch((error)=>{

              actionErrorConnection(error);
            
      })
    },[]);
    /** 
     * Ejecuta una vez servicio para mostrar popover
     * -author alSanchez - ETE
     * -version 1.0.0 - Octubre 2021
     * 
    */
         useEffect(() => {
            setAnchorEl(divRev.current);
        },[divRev]);
 
    /** 
     * Ejecuta una vez servicio para recuperar token
     * -author alSanchez - ETE
     * -version 1.0.0 - Septiembre 2021
     * 
    */

    /**
     * Realiza cambio para mostrar el selector de archivo de descarga
     * @param {*} event - Recupera el cambio del boton pulsado 
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    };

    /**
     * Cambiar valor en formulario de acuerdo al campo de contraseña ingresado
     * @author alSanchez - ETE
     * @version 1.0.0 - Enero 2023
     */
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

        /**
     * Recupera acción al ingresar valores en los input del formulario
     * @param {*} event - datos de entrada
     * @author alSanchez - ETE
     * @version 1.0.0 - Enero 2023
     */
        const handleMouseDownPassword = (event) => {
            event.preventDefault();
        };


    /**
     * Cierra las opciones de descarga al seleccionar un archivo a descargar
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    const handleClose = () => {
    setAnchorEl(null);
    };


    /**
     * Realiza la solicitud para autenticar clientes
     * @param {*} data - información del formulario de inicio de sesión
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmit = async(data) => {


        const { an8, password, rol, terms} = data;
        //Si es usuario front no permitir acceso
        if(an8==="front") {
            
            Swal.fire({
            icon: 'error',
            title: 'Error',
            html: 'No se pudo completar el inicio de sesión.  <br>' + 
            `<span class="custom-error-text">Usuario no valido</span>` ,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar'
            }
            );
            throw new Error("Usuario no valido.")
        }
        setDisabled(true);
            // Servicio de inicio de sesión
            dispatch( login( an8, password, rol, terms ))
            .then(()=>{
                    console.log('ok login')
                    props.history.push('/');
                    window.location.reload();
                }
            )
            .catch(
                (error) => {
                    console.log('error login');
                    console.log(error);
                    if(error.response){
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            html: 'No se pudo completar el inicio de sesión.  <br>' + 
                            `<span class="custom-error-text">${error.response.data.mensaje}</span>` ,
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                            }
                            );
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            html: 'No se pudo completar el inicio de sesión.  <br>' + 
                            `<span class="custom-error-text">${error}</span>` ,
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                            }
                            );
                    }
                        setDisabled(false);
                }
            );
      };

    return (
        <>
        <div className="container w-100">
            <div className="d-flex flex-row-reverse mt-2">
                <Tooltip title="Avisos" placement="top-start" arrow>
                    <Badge color="secondary" variant="dot">
                        <button 
                            className="btn custom-btn-icon-alert"
                            ref={divRev} 
                            aria-describedby={id} 
                            variant="contained"
                            onClick={handleClick}
                            type="button"
                        >
                            <i className="fas fa-bell"></i>
                        </button>
                    </Badge>
                </Tooltip>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        style:{
                            width: '400px',
                            boxShadow: 'none',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <div className="pt-4 pb-2 ps-3 pe-3 alert-container">
                        <div className="alert alert-danger" role="alert">
                            <span className='d-block pb-3'>
                                AVISO IMPORTANTE
                            </span>
                            <span className='d-block ps-3 pe-2 pb-2'>
                                Favor de leer el siguiente comunicado antes de ingresar al portal de proveedores:
                            </span>
                            <a 
                            href= {PDFTyP} 
                            target='_blank'
                            rel='nooper noreferrer'
                            className="alert-link">
                                Comunicado a Proveedores y Transportistas
                            </a>
                        </div>
                        <div className="alert alert-success" role="alert">
                            <span className='d-block pb-3'>
                                AVISO IMPORTANTE
                            </span>
                            <span className='d-block ps-3 pe-2 pb-2'>
                                A NUESTRA RED DE DISTRIBUIDORES DE CEMENTO CRUZ AZUL, PROVEEDORES Y PRESTADORES DE SERVICIOS
                            </span>
                            <span className='d-block ps-3 pe-2 pb-2'>
                                Favor de leer el siguiente comunicado antes de ingresar al portal de proveedores:
                            </span>
                            <a 
                            href= {PDFCom} 
                            target='_blank'
                            rel='nooper noreferrer'
                            className="alert-link">
                                Comunicado
                            </a>
                        </div>
                    </div>                  
                </Popover>
            </div>
        </div>
        <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-5 col-sm-9">
            <div className="login mb-5 pt-4 pr-4">
                <img src="/images/logo.jpg" alt="logo" className="w-75" />
                <h1 className="text-center pt-1 pb-1 text-title">Iniciar Sesión</h1>
                <div>
                    </div>
                <div className="container h-100">
                    <div className="row h-100 justify-content-center align-items-center">
                        <form className="col-12">
                        <div className="form-group mb-4">
                            <TextField
                                required
                                id="an8"
                                name="an8"
                                label="Número de cliente"
                                fullWidth
                                variant="outlined"
                                {...register('an8')}
                                error={!!errors.an8 }
                            />
                            <Typography variant="inherit" color="error">
                                { errors.an8?.message}
                            </Typography>
                        </div>
                            <div className="form-group mb-4">
                            <TextField
                                required
                                id="password"
                                name="password"
                                label="Password"
                                type={values.showPassword ? "text" : "password"}
                                fullWidth
                                variant="outlined"
                                {...register('password')}
                                error={!!errors.password}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                        <IconButton
                                        edge="end"
                                            onClick={()=>handleClickShowPassword()}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                        </InputAdornment>
                                }}
                            />
                            <Typography variant="inherit" color="error">
                                    {errors.password?.message}
                                </Typography>
                            </div>
                            <div className="form-group">
                                <button
                                    className="btn custom-btn pt-3 pb-3 w-100"
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={ isDisabled }
                                >
                                    Iniciar sesión { isDisabled && <i className="fas fa-spinner fa-spin"></i>}
                                </button>
                            </div>
                            <div className="form-group mb-1">
                                <div className="w-100 d-flex justify-content-between">
                                    <div className="row">
                                    <div className="col-12">
                                        <Link className="btn btn-link custom-link-color" to="/auth/register">
                                            Ir a Registro
                                        </Link>
                                    </div>
                                    <div className="col-12">
                                        <RecoverPassword/>
                                    </div>
                                    </div>
                                    <div>
                                    </div>
                                    {/* Se oculta de forma temporal */}
                                    {/* <div>
                                        <Tooltip title="Ayuda" placement="top-start" arrow>
                                            <button 
                                                className="btn custom-btn-icon-alert pe-3"
                                                ref={divRevHelp} 
                                                aria-describedby={idHelp} 
                                                variant="contained"
                                                onClick={handleClickHelp}
                                                type="button"
                                            >
                                                <i className="fas fa-question-circle"></i>
                                            </button>
                                        </Tooltip>
                                        <Popover
                                            id={idHelp}
                                            open={openHelp}
                                            anchorEl={anchorElHelp}
                                            onClose={handleCloseHelp}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            PaperProps={{
                                                style:{
                                                    width: '400px',
                                                    boxShadow: 'none',
                                                    backgroundColor: 'transparent'
                                                }
                                            }}
                                        >
                                            <div className="pt-4 pb-2 ps-3 pe-3 alert-container">
                                                <div className="alert alert-light" role="alert">
                                                    <span className='d-block ps-3 pe-2 pb-2'>
                                                        Temas de ayuda:
                                                    </span>
                                                    <a 
                                                    href= {PDFReg} 
                                                    target='_blank'
                                                    rel='nooper noreferrer'
                                                    className="alert-link">
                                                        Manual de usuario | proceso de registro
                                                    </a>
                                                </div>
                                            </div>                  
                                        </Popover>
                                    </div> */}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            </div>
        </div>    
        </div>
            
            <Footer />
        </>
    )
}

LoginScreen.propTypes = {
    history: PropTypes.object
}

export const RecoverPassword = () => {

    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [recoveryForm, setRecoveryForm] = useState({
      an8: '',
    });

    const validationSchema = Yup.object().shape({
      an8: Yup.string().required('an8 requerido'),
    });
    
      const {
        register,
        reset,
        handleSubmit,
        formState: { errors }
      } = useForm({
        resolver: yupResolver(validationSchema)
      });
  useEffect(() => {
        TokenService.getInitToken()
    }, []);

      /**
   * Solicita la apertura del modal para recuperar contraseña
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
    const handleOpen = () => {
        const initValues = {
            an8: '',
        }
        setRecoveryForm(initValues);
        reset(initValues);
        setOpen(true);
    };

    /**
   * Realiza el cambio de estado para los datos del formulario
   * @param {*} event - acción recuperada del elemento
   * @param {string} input - nombre del campo de entrada
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
    const handleChangeValue =(event, input) =>{

        const inputValue = event.target.value;
        const arrayValue = {...recoveryForm, [input] : inputValue};
    
        setRecoveryForm(arrayValue);
        reset(arrayValue);
    }

    /**
   * Realiza el cierre del modal de contraseña
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
    const handleClose = () => {
        setOpen(false);
    };

    /**
   * Solicita la recuperación de la contraseña
   * @param {object} data - información del formulario de recuperación
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
    const handleRecovery = (data) =>{
        setIsLoading(true);
        
        authService.recoverPassword(data.an8).then(
            (response) => {
                setIsLoading(false);
                setOpen(false);
                if(response.length > 1){
                    Swal.fire({
                      icon: 'error',
                      title: 'Error al realizar recuperación de contraseña.',
                      html:`${response}`,
                      showConfirmButton: true,
                      confirmButtonText: 'Aceptar'
                    });
            
                  } else{
                    Swal.fire({
                      icon: 'success',
                      title: 'Contraseña recuperada exitosamente.',
                      text: 'En breve recibirá un correo en su dirección registrada.',
                      showConfirmButton: true,
                      confirmButtonText: 'Aceptar'
                    }) 
                  }
            },
            (error) => {
                setIsLoading(false);
                setOpen(false);
                actionErrorConnection(error, 'Error al realizar recuperación de contraseña.');                
            }
        );
    }

    return (
        <>
            <div className="">
            <Link onClick={()=>handleOpen()} className="btn btn-link custom-link-color">
                Recuperar contraseña
            </Link>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
            >
            <div className="custom-modal-pass">
                <form>
                    <div className='ms-1'>
                        <div className='row'>
                            <div className="col-12">
                                <div className="w-100 m-2">
                                <h2 className="text-modal-title-pass text-center pt-1 pb-1 " >Recuperar contraseña</h2>
                                </div>
                            </div>
                            <div className="col-md-12 pt-5 pb-2">
                                <div className="row mb-3">
                                    <div className="form-group mb-4">
                                        <TextField
                                            required
                                            id="an8"
                                            name="an8"
                                            label="Número de cliente"
                                            fullWidth
                                            variant="outlined"
                                            {...register('an8')}
                                            onChange={event => handleChangeValue(event, 'an8')}
                                            error={!!errors.an8 }
                                        />
                                        <Typography variant="inherit" color="error">
                                            { errors.an8?.message}
                                        </Typography>
                                    </div>
                                </div>  
                            </div>
                        </div>
                        <div className="d-flex flex-row-reverse me-3 mb-3 ms-3">
                            <div className="col-12 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                                <button  
                                    className="custom-btn pt-2 pb-2 ps-3 pe-3" 
                                    onClick={ handleSubmit(handleRecovery)}
                                    disabled={isLoading}
                                    >
                                    <span className="me-1">Aceptar { isLoading && <i className="fas fa-spinner fa-spin"></i>}</span>
                                    </button>
                                <button  
                                className="custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                                type="button"
                                onClick={handleClose}
                                >
                                        Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            </Modal>
      </>
    )
}